import { render, staticRenderFns } from "./Reductions.vue?vue&type=template&id=6e620b77&"
import script from "./Reductions.vue?vue&type=script&lang=js&"
export * from "./Reductions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports